import { Auth } from '@supabase/auth-ui-react';
// DEPRECADO https://github.com/supabase-community/auth-ui  debemos migrar
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from 'common/src/supabase';

type props = {
  setView: (view: 'login' | 'register') => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Login(_props: props) {
  return (
    <div className='flex h-screen w-full items-center justify-center bg-gray-200'>
      <div className='w-full max-w-[400px] rounded-lg bg-white p-8 shadow'>
        <Auth
          supabaseClient={supabase}
          appearance={{ theme: ThemeSupa }}
          providers={[]}
          showLinks={false}
        />
      </div>
    </div>
  );
}
